var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C3.81318 0 0 3.81318 0 8.5C0 13.1868 3.81318 17 8.5 17C13.1868 17 17 13.1868 17 8.5C17 3.81318 13.1868 0 8.5 0ZM11.9379 10.9362C12.0762 11.0745 12.0762 11.2988 11.9379 11.4371L11.4371 11.9379C11.2988 12.0761 11.0746 12.0761 10.9362 11.9379L8.5 9.50164L6.06375 11.9379C5.9254 12.0762 5.70121 12.0762 5.56285 11.9379L5.06212 11.4371C4.92376 11.2988 4.92376 11.0746 5.06212 10.9362L7.49836 8.49997L5.06212 6.06372C4.92376 5.92543 4.92376 5.70118 5.06212 5.56285L5.56285 5.06208C5.70121 4.92379 5.9254 4.92379 6.06375 5.06208L8.5 7.49833L10.9362 5.06208C11.0746 4.92379 11.2988 4.92379 11.4371 5.06208L11.9379 5.56285C12.0762 5.70114 12.0762 5.9254 11.9379 6.06372L9.50164 8.49997L11.9379 10.9362Z",
    fill: "#7195AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove-icon.3f633ffad07dce291687390ab201529d.svg";
export { ForwardRef as ReactComponent };